<template>
    <div>
        <loading-overlay :active="pageLoading" :is-full-page="true" :lock-scroll="true" loader="dots" color="#0168b7"
                background-color="#ffffff" opacity="1" />

        <div class="content-wrapper">
            <h2>ファンド</h2>
            <watch-funds @been-ready="onChildBeenReady" />
        </div>
    </div>
</template>

<script>
import LoadingOverlay from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import WatchFunds from "../components/WatchFunds"

export default {
    name: 'TabWatchList',
    components: {
        WatchFunds,
        LoadingOverlay
    },
    data: () => ({
        'pageLoading': true,
        'children': 2,
    }),
    created() {},
    mounted() {},
    methods: {
        onChildBeenReady: function() {
            if( ( this.children = this.children - 1 ) < 1 ){
                this.pageLoading = false
            }
        }
    }
}
</script>